import { Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[appAutoScroll]',
    exportAs: 'autoScroll'
})
export class AutoScrollDirective implements OnInit, OnDestroy {
  private lastScrollTop = 0;
  private shouldAutoScroll = true;
  private scrollListener?: () => void;
  private lastScrollHeight = 0;

  constructor(
    private el: ElementRef,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    // Run scroll event handler OUTSIDE Angular's zone to prevent change detection storms
    this.ngZone.runOutsideAngular(() => {
      this.scrollListener = () => this.onScroll();
      this.el.nativeElement.addEventListener('scroll', this.scrollListener, { passive: true });
    });
    this.lastScrollHeight = this.el.nativeElement.scrollHeight;
  }

  ngOnDestroy() {
    if (this.scrollListener) {
      this.el.nativeElement.removeEventListener('scroll', this.scrollListener);
    }
  }

  private onScroll() {
    const element = this.el.nativeElement;
    const currentScrollTop = element.scrollTop;

    // User scrolled UP manually - disable auto-scroll
    if (currentScrollTop < this.lastScrollTop) {
      this.shouldAutoScroll = false;
    }
    // User is at bottom (within 50px threshold) - enable auto-scroll
    else if (currentScrollTop + element.clientHeight >= element.scrollHeight - 50) {
      this.shouldAutoScroll = true;
    }

    this.lastScrollTop = currentScrollTop;
    this.lastScrollHeight = element.scrollHeight;
  }

  scrollToBottom(): void {
    const element = this.el.nativeElement;
    const currentScrollHeight = element.scrollHeight;
    const currentScrollTop = element.scrollTop;
    const clientHeight = element.clientHeight;

    // Check if user was near the bottom BEFORE content was added
    // We use lastScrollHeight (before content added) to determine this
    const wasNearBottom = currentScrollTop + clientHeight >= this.lastScrollHeight - 100;

    // Only auto-scroll if user was already near the bottom
    if (wasNearBottom) {
      element.scrollTop = currentScrollHeight;
    }

    // Update lastScrollHeight for next time
    this.lastScrollHeight = currentScrollHeight;
  }

  get autoScroll(): boolean {
    return this.shouldAutoScroll;
  }

  set autoScroll(value: boolean) {
    this.shouldAutoScroll = value;
  }
}
